module.exports = __webpack_public_path__ + "img/KJJZHMD_Android.9812b60e.png";